import { Scene } from "../../tools/Scene";
import { GameManager } from "../../managers/GameManager";

export class DevelopmentScene extends Scene{

    x:number;
    y:number;
    text:Phaser.GameObjects.Text|null = null;
    assetUrl:string;

    constructor(sceneConfig,x:number,y:number,assetUrl:string){
        super(sceneConfig);
        this.x = x;
        this.y = y;
        this.assetUrl=assetUrl;
    }

    preload(){
        this.load.json('buildJson', this.assetUrl + '/assets/eyeexam/strings/build.json');
    }

    prescaleCreate(){
        let position = this.scaleManager.getRelativePosition(this.x,this.y,false);
        let style = { fontFamily: 'Arial',fontSize: 16, color: '#FFFFFF'};
        let cache = (<any>this.cache).json.get('buildJson');
        (<GameManager>GameManager.instance).buildConfig = cache;
        this.text = this.add.text(position.x,position.y,`Development Build: v${cache.version}`,style);
        this.text.setOrigin(this.x,this.y);
        this.text.visible = false;
    }

    reorient(landscape:boolean):void {
        let position = this.scaleManager.getRelativePosition(this.x,this.y,false);
        this.text!.setPosition(position.x,position.y);
    }

    update(){
        this.scene.bringToTop(this.scene.settings.key);
    }
}